// Components/MessagesArea/components/LoadingIndicator.jsx
import React from 'react';
import { Box } from '@mui/material';
import LoadingProcess from '../../LoadingProcess';

const LoadingIndicator = ({ type, text }) => {
    if (type === 'mini') {
        return (
            <Box sx={{ textAlign: 'center', padding: 1 }}>
                <LoadingProcess text={text} tipo="mini" />
            </Box>
        );
    }
    
    return <LoadingProcess text={text} tipo={type} />;
};

export default LoadingIndicator;